// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rabbit-sign-docs .rabbit-sign-document-card {
  padding: 0px;
}
.rabbit-sign-docs .rabbit-sign-document-card .ant-card-head,
.rabbit-sign-docs .rabbit-sign-document-card .ant-card-body {
  padding-left: 10px;
}
.rabbit-sign-docs .rabbit-sign-document-card .rabbit-sign-document-no-marging {
  margin: 0px;
}
.rabbit-sign-docs .rabbit-sign-document-card .rabbit-sign-docs-table .rabbit-sign-doc-cell {
  padding: 2px 0px 2px 0px !important;
}
.rabbit-sign-docs .rabbit-sign-document-card .rabbit-sign-docs-table .rabbit-sign-doc-cell .rabbit-sign-document-info-popover {
  width: 500px;
}
.rabbit-sign-docs .rabbit-sign-document-card .rabbit-sign-docs-table .rabbit-sign-doc-cell .rabbit-sign-document-info-popover .rabbit-sign-document-info-popover-icon {
  margin-right: 10px;
}
.rabbit-sign-docs .rabbit-sign-document-card .rabbit-sign-docs-table .rabbit-sign-doc-cell .rabbit-sign-document-signers-popover {
  padding: 0px 12px;
  display: inline-block;
}
.rabbit-sign-docs .rabbit-sign-document-card .rabbit-sign-docs-table .rabbit-sign-signer-list .rabbit-sign-signer {
  margin: 3px 0px;
}
`, "",{"version":3,"sources":["webpack://./src/components/rabbit-sign/components/esign-documents/styles.less"],"names":[],"mappings":"AAAA;EAEI,YAAA;AAAJ;AAFA;;EAMM,kBAAA;AAAN;AANA;EAUM,WAAA;AADN;AATA;EAeQ,mCAAA;AAHR;AAZA;EAkBU,YAAA;AAHV;AAfA;EAqBY,kBAAA;AAHZ;AAlBA;EA0BU,iBAAA;EACA,qBAAA;AALV;AAtBA;EAgCU,eAAA;AAPV","sourcesContent":[".rabbit-sign-docs {\n  .rabbit-sign-document-card {\n    padding: 0px;\n    \n    .ant-card-head,\n    .ant-card-body {\n      padding-left: 10px;\n    }\n\n    .rabbit-sign-document-no-marging {\n      margin: 0px;\n    }\n\n    .rabbit-sign-docs-table {\n      .rabbit-sign-doc-cell {\n        padding: 2px 0px 2px 0px !important;\n\n        .rabbit-sign-document-info-popover {\n          width: 500px;\n\n          .rabbit-sign-document-info-popover-icon {\n            margin-right: 10px;\n          }\n        }\n\n        .rabbit-sign-document-signers-popover {\n          padding: 0px 12px;\n          display: inline-block;\n        }\n      }\n      .rabbit-sign-signer-list {\n        .rabbit-sign-signer {\n          margin: 3px 0px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
